<div class="index-head">
    <span>Upgrade Your Plan</span>
</div>
<div class="padding-index">
    <span>Upgrade to the premium plan for additional features.</span>
</div>

<div class="upgrade" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
    <button (click)="upgrade()" [attr.guide]="'restriction-btn-1-1' + '__' + sanitizeUrl(url)" mat-raised-button>
        Upgrade
    </button>
</div>